import { updates } from "@/mocks/movieData";
import SectionHeading, { Section } from "./SectionHeading";

export default function UpdateLog() {
  return (
    <Section id="updates" className="bg-background-100">
      <SectionHeading
        eyebrow="维护记录"
        accent="secondary"
        title="本页内容的整理与更新说明"
        description="线路状态、使用说明和片单会随着实际情况调整。下面是最近几次比较重要的整理记录，方便你了解本页目前维护到什么程度。"
      />

      <ol className="relative border-l border-background-300 ml-2 md:ml-4 space-y-6">
        {updates.map((item) => (
          <li key={item.id} className="pl-5 md:pl-8">
            <span className="absolute -left-[7px] mt-1.5 w-3.5 h-3.5 rounded-full bg-accent-500 border-2 border-background-100"></span>
            <time className="text-xs font-label text-secondary-700 bg-secondary-100 px-2 py-0.5 rounded-full">
              {item.date}
            </time>
            <h3 className="mt-2 font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
          </li>
        ))}
      </ol>
    </Section>
  );
}